// FeedUiController.ts

import { setFavicon } from './favicon'

type FeedStatus = 'CONNECTED' | 'CONNECTING' | 'DISCONNECTED'

export class FeedUiController {
    private static base = 'Rupeezy'
    private static status: FeedStatus = 'DISCONNECTED'
    private static symbol: string | null = null
    private static price: number | null = null


    static setStatus(status: FeedStatus): void {
        if (this.status === status) return

        this.status = status
        setFavicon(status)
        this.render(true)
    }

    static setSymbol(symbol: string): void {
        this.symbol = symbol
        this.render()
    }

    static setPrice(price: number): void {
        this.price = price
        this.render()
    }

    private static render(force = false): void {

        if (!this.symbol || this.price == null) {
            document.title = `${this.base}`
            return
        }

        document.title =
            `${this.symbol} · ₹${this.price.toFixed(2)}`
    }
}
